import styled from 'styled-components';

const ContactInfo = styled.div`
  .row {
    display: flex;
    height: 500px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      height: 850px;
      gap: 50px;
    }
  }
  .col-1 {
    font-family: 'Poppins', sans-serif;
    padding: 20px;
    width: 50%;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 100%;
      text-align: center;
      padding: 0;
    }

    h3 {
      color: ${(props) => props.theme.color.lightBlue};
    }
    h1 {
      color: ${(props) => props.theme.color.darkBlue};
      font-size: 2.5rem;
      font-weight: bold;
      margin-bottom: 20px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 1.6rem;
      }
    }
    p {
      margin: 30px 0;
    }
    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span {
          color: ${(props) => props.theme.color.lightBlue};
          margin-right: 30px;
          font-size: 1.5rem;
        }
        a {
          color: ${(props) => props.theme.color.darkBlue};
          text-decoration: none;
        }
      }
    }
  }
  .col-2 {
    padding: 20px;
    height: 200px;
    width: 50%;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 100%;
      text-align: center;
      height: 300px;
      padding: 0;
    }

    h2 {
      margin-bottom: 20px;
    }

    textarea {
      font-family: 'Poppins', sans-serif;
      padding: 20px;
      width: 100%;
      height: 200px;
      margin-bottom: 20px;
    }
    .mail {
      display: flex;
      justify-content: space-between;

      input {
        font-family: 'Poppins', sans-serif;
        padding: 0 20px;
        height: 50px;
        margin-bottom: 20px;
        width: 48%;
      }
    }
    button {
      padding: 20px;
      outline: none;
      background: rgb(242, 87, 76);
      border-radius: 40px;
      border: none;
      width: 50%;
      font-size: 1.1rem;
      color: #fff;
      margin-top: 10px;

       @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
      }
    }
    input[type='button'] {
      border: none;
      padding: 20px 60px;
      border-radius: 25px;
      background-color: rgb(252, 210, 0);

      &:hover {
        background-color: ${(props) => props.theme.color.darkBlue};
        color: #fff;
      }
    }
  }
`;

export { ContactInfo };
